__turbopack_context__.v({
  "clicked": "UserPageSubscriptions-module-scss-module__kp_p3a__clicked",
  "nftSubscriptionsTable": "UserPageSubscriptions-module-scss-module__kp_p3a__nftSubscriptionsTable",
  "notSubscribedTag": "UserPageSubscriptions-module-scss-module__kp_p3a__notSubscribedTag",
  "sendBtn": "UserPageSubscriptions-module-scss-module__kp_p3a__sendBtn",
  "subscribedTag": "UserPageSubscriptions-module-scss-module__kp_p3a__subscribedTag",
  "subscriptionHistoryEntry": "UserPageSubscriptions-module-scss-module__kp_p3a__subscriptionHistoryEntry",
  "tagContainer": "UserPageSubscriptions-module-scss-module__kp_p3a__tagContainer",
  "topUpHistoryAccordionBody": "UserPageSubscriptions-module-scss-module__kp_p3a__topUpHistoryAccordionBody",
  "topUpHistoryAccordionButton": "UserPageSubscriptions-module-scss-module__kp_p3a__topUpHistoryAccordionButton",
});
